var _defs, _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _path, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _path2, _g35, _g36, _g37, _g38, _g39, _g40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5245473PersonAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 812 730",
    width: 812,
    height: 730,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5245473-ai") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1251.2 759h-1267c-19.61 0-35.5-15.89-35.5-35.5v-741c0-19.61 15.89-35.5 35.5-35.5h1267c19.61 0 35.5 15.89 35.5 35.5v741c0 19.61-15.89 35.5-35.5 35.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m700.28 457.32h-413.19c-4.48 0-8.1-3.62-8.1-8.09v-249.62c0-4.47 3.62-8.09 8.1-8.09h413.19c4.47 0 8.1 3.62 8.1 8.09v249.62c0 4.47-3.63 8.09-8.1 8.09z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre } \n\t\t.s0 { fill: #c7c2f9 } \n\t\t.s1 { fill: #2d3962 } \n\t\t.s2 { fill: #aca0f2 } \n\t\t.s3 { fill: #ffffff } \n\t\t.s4 { fill: #eba23e } \n\t\t.s5 { fill: #f9bf7a } \n\t\t.s6 { fill: #ffceab } \n\t\t.s7 { fill: #e8b69c } \n\t\t.s8 { fill: #efedef } \n\t\t.s9 { fill: #9bbbea } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>",
    clipPath: "url(#cp1)",
    style: {
      opacity: 0.2
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m912 282.9c-9.4 0-21.2-12.1-28.5-29.9-3.8-9.6-5.7-19.4-5.3-27.5 0.5-8.3 3.4-14 8.2-16 4.8-1.9 10.8 0.1 17 5.8 5.9 5.5 11.3 13.9 15.2 23.4 8.3 20.4 7 39.5-2.8 43.5q-1.8 0.7-3.8 0.7zm-21.8-72.1q-1.6 0-3.1 0.6c-4 1.6-6.5 6.7-6.9 14.2-0.4 7.8 1.4 17.3 5.2 26.6 7.7 19 21 31.6 29.6 28.1 8.7-3.5 9.5-21.8 1.8-40.8-3.8-9.3-9-17.4-14.8-22.7-4.2-3.9-8.3-6-11.8-6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m885.6 284.3q-2.1 0-3.9-0.7c-3.1-1.1-5.6-3.5-7-7.1-3.6-8.8-1.2-23.1 6-37.5 10.5-20.6 27.9-34.3 38.8-30.6 3.2 1.1 5.6 3.6 7.1 7.2 3.5 8.7 1.2 23.1-6.1 37.4-9.3 18.4-24.1 31.3-34.9 31.3zm29.9-74.5c-10 0-24 12.5-33 30.1-6.9 13.7-9.3 27.7-6 35.8 1.3 3.1 3.2 5.1 5.9 6 10 3.5 26.3-9.8 36.3-29.6 6.9-13.6 9.3-27.7 6-35.8-1.2-3-3.2-5.1-5.8-6q-1.6-0.5-3.4-0.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s0",
    d: "m916.4 269.4c-7.7 0-16.5-1.5-25.2-4.5-15.2-5.3-26.9-13.9-30.4-22.7-1.5-3.6-1.4-7 0.1-10 5.2-10.3 27.3-12.6 49.1-5 15.3 5.2 26.9 13.9 30.5 22.6 1.4 3.6 1.4 7.1-0.1 10.1-3.2 6.2-12.4 9.5-24 9.5zm-24.5-6.4c20.9 7.2 41.9 5.4 46.7-4 1.2-2.5 1.2-5.3 0-8.4-3.3-8.1-14.7-16.5-29.2-21.5-21-7.3-41.9-5.5-46.7 4-1.3 2.5-1.3 5.3-0.1 8.4 3.3 8.1 14.8 16.5 29.3 21.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m897.1 237.2c5.3-2.1 11.4 0.5 13.5 5.8 2.2 5.3-0.4 11.3-5.7 13.5-5.3 2.1-11.4-0.4-13.5-5.7-2.2-5.3 0.4-11.4 5.7-13.6z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m708.3 468.4h-429.3c-4.9 0-8.9-4-8.9-8.9v-270.1c0-4.9 4-8.9 8.9-8.9h429.3c5 0 9 4 9 8.9v270.1c0 4.9-4 8.9-9 8.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m700.3 457.3h-413.2c-4.5 0-8.1-3.6-8.1-8.1v-249.6c0-4.5 3.6-8.1 8.1-8.1h413.2c4.5 0 8.1 3.6 8.1 8.1v249.6c0 4.5-3.6 8.1-8.1 8.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.4
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m279 222.3v-22.7c0-4.5 3.6-8.1 8.1-8.1h413.2c4.5 0 8.1 3.6 8.1 8.1v22.7z"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m298.4 208.4c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.4
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m311.1 208.4c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m323.3 208.4c0 2.1-1.7 3.8-3.8 3.8-2.1 0-3.8-1.7-3.8-3.8 0-2.1 1.7-3.8 3.8-3.8 2.1 0 3.8 1.7 3.8 3.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.2
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m539.3 425.8h-231.5c-2.9 0-5.2-2.3-5.2-5.2v-160.1c0-2.9 2.3-5.2 5.2-5.2h231.5c2.9 0 5.3 2.3 5.3 5.2v160.1c0 2.9-2.4 5.2-5.3 5.2z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m357.3 309.5h-37.5c-1.3 0-2.3-1-2.3-2.3v-34.4c0-1.3 1-2.3 2.3-2.3h37.5c1.3 0 2.3 1 2.3 2.3v34.4c0 1.3-1 2.3-2.3 2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m349.8 290.2c0 6.2-5 11.2-11.2 11.2-6.3 0-11.3-5-11.3-11.2 0-6.2 5-11.3 11.3-11.3 6.2 0 11.2 5.1 11.2 11.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m393.2 278.6h-25.9c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h25.9c0.6 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 285.8h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 291.8h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 297.8h-35.5c-0.7 0-1.2-0.6-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.6-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m384.3 303.8h-17c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h17c0.7 0 1.2 0.6 1.2 1.3 0 0.7-0.5 1.2-1.2 1.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m482.9 334.4h-56.2c-1.9 0-3.5-1.6-3.5-3.4v-51.6c0-1.9 1.6-3.4 3.5-3.4h56.2c1.9 0 3.4 1.5 3.4 3.4v51.6c0 1.8-1.5 3.4-3.4 3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m469.8 320.3h-30v-29.9h30z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m482.9 403.1h-56.2c-1.9 0-3.5-1.6-3.5-3.4v-51.6c0-1.9 1.6-3.4 3.5-3.4h56.2c1.9 0 3.4 1.5 3.4 3.4v51.6c0 1.8-1.5 3.4-3.4 3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m454.8 389c-8.3 0-15-6.7-15-15 0-8.2 6.7-14.9 15-14.9 8.3 0 15 6.7 15 14.9 0 8.3-6.7 15-15 15z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m518.7 304h-25.8c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h25.8c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 311.1h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 317.1h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.6 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.6 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 323.1h-35.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m509.9 329.2h-17c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.3 1.2-1.3h17c0.6 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.3-1.2 1.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m518.7 373.1h-25.8c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h25.8c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 380.2h-35.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 386.3h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m528.4 392.3h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.6 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.6 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m509.9 398.3h-17c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h17c0.6 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.2-1.2 1.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m357.3 360.1h-37.5c-1.3 0-2.3-1-2.3-2.3v-34.5c0-1.2 1-2.2 2.3-2.2h37.5c1.3 0 2.3 1 2.3 2.2v34.5c0 1.3-1 2.3-2.3 2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m348.5 350.5h-19.9v-20h19.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m393.2 329.2h-25.9c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h25.9c0.6 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 336.3h-35.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 342.4h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 348.4h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.6 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.6 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m384.3 354.4h-17c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h17c0.7 0 1.2 0.6 1.2 1.3 0 0.7-0.5 1.2-1.2 1.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m357.3 410.7h-37.5c-1.3 0-2.3-1-2.3-2.3v-34.5c0-1.2 1-2.3 2.3-2.3h37.5c1.3 0 2.3 1.1 2.3 2.3v34.5c0 1.3-1 2.3-2.3 2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m344.5 381.1h-11.9l-6 10.3 6 10.4h11.9l6-10.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m393.2 379.8h-25.9c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h25.9c0.6 0 1.2 0.6 1.2 1.3 0 0.7-0.6 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 386.9h-35.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.2-1.3 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 393h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.3 1.2-1.3h35.5c0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m402.8 399h-35.5c-0.7 0-1.2-0.6-1.2-1.3 0-0.7 0.5-1.2 1.2-1.2h35.5c0.7 0 1.3 0.5 1.3 1.2 0 0.7-0.6 1.3-1.3 1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m384.3 405h-17c-0.7 0-1.2-0.5-1.2-1.2 0-0.7 0.5-1.3 1.2-1.3h17c0.7 0 1.2 0.6 1.2 1.3 0 0.7-0.5 1.2-1.2 1.2z"
  }))))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "<Clip Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m649.4 430.1l-76.7-0.5c0 0-16 93.1-16.8 125.7l91.4 2.3c0 0 5.5-40.5 6.1-51.8 1.1-18.2-4-75.7-4-75.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m646.5 333.7c4.6 13.1 18.1 72 15 126l-96.7-2.3c0 0 6.1-56.2 19.1-93.1 5.8-16.5 23.5-31.9 26.8-35.6l31.3 1.8c2.1 0.2 3.8 1.4 4.5 3.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m650.2 463.7c-3.3 5.6-6 9.5-7.5 11.8-0.9 1.5-1.8 3-3 4.7-0.7 1.2 1.4 3.3 2.7 2l0.3-0.4c-0.5 1.4 1.1 1.9 1.4 2 0.7 0.2 1.4-0.4 1.4-0.4 0 0-0.2 1.1 1.2 1.7 0.8 0.3 1.4 0.3 2-0.3 0 0 1.3 1.2 2.6 0 0.7-0.7 6-6.6 13.1-16z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m649 485.7q-0.2 0-0.5-0.2c-0.3-0.3-0.3-0.7-0.1-1.1 0 0 1.9-2.3 3.4-4.9 0.2-0.3 0.6-0.4 1-0.2 0.3 0.2 0.5 0.6 0.3 1-1.5 2.6-3.4 5-3.5 5.1-0.1 0.2-0.4 0.3-0.6 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m645.5 484.5q-0.3 0-0.5-0.2c-0.3-0.3-0.4-0.8-0.1-1.1 0 0 2.5-3.1 3.9-5.6 0.2-0.4 0.7-0.5 1.1-0.3 0.3 0.2 0.5 0.7 0.2 1-1.4 2.7-3.9 5.7-4 5.9-0.2 0.2-0.4 0.3-0.6 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m642.5 482.9q-0.3 0.1-0.5-0.1c-0.3-0.3-0.4-0.8-0.1-1.1 0 0 2.5-3.1 3.9-5.6 0.2-0.4 0.7-0.5 1.1-0.3 0.3 0.2 0.4 0.7 0.2 1-1.5 2.7-3.9 5.7-4 5.9-0.2 0.2-0.4 0.2-0.6 0.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m693.1 401.6c-0.9-25.1-37.1-77.4-53.5-69.9-18.9 8.8 17.4 62.6 24.1 76.1 0.7 1.5-17.1 56.5-17.1 56.5 1.5 9 17.5 10.7 17.5 10.7 0 0 30.3-37.1 29-73.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m661.2 403.3c-0.2 0-0.5-0.1-0.6-0.3l-14.2-29.1c-0.2-0.3 0-0.6 0.2-0.8 0.3-0.1 0.7 0 0.8 0.3l14.3 29c0.1 0.3 0 0.7-0.3 0.8q-0.1 0.1-0.2 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m647.2 462.5q-0.1 0-0.2 0c-0.3-0.1-0.4-0.4-0.3-0.7l14.9-46.8c0.1-0.3 0.4-0.5 0.7-0.4 0.3 0.1 0.5 0.4 0.4 0.7l-14.9 46.8c-0.1 0.3-0.3 0.4-0.6 0.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m593 266.8c0 0-5.6 22.1-4.2 35.5 1.3 12.8 9.4 21 20.8 21l1 8.7c0 0 15.2 4.1 29.9-0.3l0.2-20.1-0.1-42.7-5.5-8.4-37.9-5.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m626.1 319.3c-1.5 1.6-15.3 9.5-15.8 9.8 0 0-0.9-7.1-0.8-6.2 0 0.4 3 0.5 6.7-0.5 3.4-1 6.8-2.6 8.9-3.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m610.9 323.8c-4.2 0-8.6-1.1-13-4.1-0.3-0.1-0.3-0.5-0.2-0.8 0.2-0.2 0.6-0.3 0.8-0.1 9.9 6.5 20 3.5 26.7-0.3 0.2-0.2 0.6-0.1 0.8 0.2 0.1 0.3 0 0.7-0.3 0.8-4 2.3-9.1 4.3-14.8 4.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m620.9 287.5c-0.4 1.7-2.1 2.8-3.8 2.4-1.7-0.4-2.8-2.2-2.3-3.9 0.4-1.7 2.1-2.7 3.8-2.3 1.7 0.4 2.7 2.1 2.3 3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m598.5 284.1c0.6-1.7 2.4-2.5 4-1.9 1.7 0.6 2.5 2.4 1.9 4-0.6 1.7-2.4 2.5-4.1 1.9-1.6-0.6-2.4-2.4-1.8-4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m616.2 277.6c0.9-0.8 2.5-0.5 3.7-0.3 1.1 0.2 3.1 0.6 3.9 1.4 0.4 0.5 0.4 1.1 0.2 1.6-0.3 0.6-1.2 0.9-2 1-0.7 0-1.4-0.1-2.1-0.2q-1.5-0.3-2.9-0.6c-0.3 0-0.5-0.1-0.7-0.2-0.6-0.4-0.7-1.4-0.6-1.9q0.2-0.5 0.5-0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m604.9 276.5c-0.7-0.9-2.3-1.1-3.5-1.2-1.1-0.1-3.1-0.3-4.1 0.4-0.5 0.3-0.8 0.9-0.6 1.4 0.1 0.7 0.8 1.2 1.6 1.5 0.7 0.2 1.4 0.3 2.1 0.3q1.5 0.2 3 0.3c0.2 0 0.5 0 0.7-0.1 0.6-0.2 1-1.2 1-1.7q0-0.5-0.2-0.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m608.4 294.5q0 0-0.1 0c-0.3-0.1-0.5-0.3-0.5-0.7 0.1-0.2 0.1-0.5 0.2-0.9 0-0.7 0.1-1.5 0.2-2 0.1-0.3 0.4-0.5 0.7-0.5 0.3 0.1 0.5 0.4 0.5 0.7-0.1 0.5-0.2 1.2-0.3 1.9 0 0.4-0.1 0.8-0.1 1-0.1 0.3-0.3 0.5-0.6 0.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m608.3 297.4c-0.6 0-1.4-0.1-2-0.6-0.8-0.6-1-1.7-0.6-2.6q0.4-0.5 1-0.8c0.7-0.3 1.4-0.3 2.1-0.1 0.3 0.1 0.4 0.5 0.3 0.8-0.1 0.3-0.4 0.4-0.7 0.3-0.4-0.1-0.8-0.1-1.2 0.1q-0.3 0.1-0.5 0.3c-0.1 0.3 0 0.8 0.4 1.1 0.4 0.4 1.1 0.4 1.5 0.3 0.3 0 0.6 0.2 0.6 0.5 0.1 0.4-0.2 0.6-0.5 0.7q-0.2 0-0.4 0z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m609.3 305.7c-1.2 0-2.5-0.3-3.6-0.9-0.2-0.2-0.3-0.5-0.2-0.8 0.2-0.3 0.5-0.4 0.8-0.2 2.2 1.2 5.2 0.9 7.2-0.7 0.2-0.2 0.6-0.2 0.8 0 0.2 0.3 0.2 0.6-0.1 0.8-1.3 1.2-3.1 1.8-4.9 1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m590.9 253.5c0 0-6.2 5.8-3.5 13.9 1.2 3.6 5.2 5.8 8.6 6.3 5.7 0.7 11.2-2.3 11.3-2.3-0.1 0.1 2.7 4.9 10 5.8 4.9 0.7 7.8 0.3 10.6-2.8 0 0 0.6 7.5 8.1 8.8 0 0-1.7 24.6 3.4 32 0.4 0.6 14.4 7.2 15.3-6.1 0 0 12.5 1.5 12.8-11.7 0 0 12.2-9.3 5.6-23.4 0 0 5.6-13.8-5.5-18.7 0 0 3-18.4-18.1-19.3 0 0-3.7-5-9.4-6.2-5.9-1.3-9.6-0.7-15 2.7 0 0-4-3.4-11.3-2.1-6.5 1.2-7.7 6.1-7.7 6.1 0 0-7.4-1.4-12.2 5.6-1.8 2.6-3.2 6.2-3 11.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m635.1 290.2c3.7-1.4 10.8-3.9 14.2-1 2.8 2.4 2.7 6.9 0 9.6-4.4 4.5-12.5 6.1-15 6.7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m646.7 293.9q-0.1 0-0.2 0c-2.7-1.2-4.7-0.4-4.7-0.3-0.3 0.1-0.6 0-0.7-0.3-0.2-0.3 0-0.7 0.2-0.8 0.1 0 2.5-1.1 5.6 0.3 0.3 0.2 0.5 0.5 0.3 0.8-0.1 0.2-0.3 0.3-0.5 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m642.9 297.4q-0.1 0-0.3-0.1c-0.3-0.2-0.3-0.6-0.1-0.8 0 0 0.8-1.1 1.7-3.3 0.1-0.3 0.5-0.4 0.8-0.3 0.3 0.1 0.4 0.5 0.3 0.8-1 2.3-1.9 3.4-1.9 3.5q-0.2 0.2-0.5 0.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m625.9 334.6c-9.4 0-16.7-2.4-16.8-2.5-0.3-0.1-0.4-0.4-0.3-0.7 0.1-0.3 0.4-0.5 0.7-0.4 0.2 0.1 15.8 5.3 30.8 0.2 0.3-0.1 0.6 0.1 0.7 0.4 0.1 0.3 0 0.6-0.3 0.7-5.1 1.7-10.2 2.3-14.8 2.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m505.9 369.7c0 0-3.1-3.2-6-5.8-3.5-3.2-8.3-8-11.5-10.5-1.6-1.2-4.5-4.5-5.9-3-1.8 1.9 5.3 7.6 5.3 7.6-1.6-0.6-2.4-1.2-3.6 0.1-1.3 1.5 0.9 3.6 0.9 3.6 0 0-1.6-1.1-3 0.5-1.4 1.7 1.1 3.8 1.6 4.6 0 0-1.1-0.1-1.7 0.5-0.5 0.4-0.5 1.5 0 2.3 0.3 0.4 1.8 2.1 6 5.2 3.6 2.6 7.7 4.9 7.7 4.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m496.3 355.2c2-0.7 3.2 2 4.4 5.4 0.5 1.6 2.3 5.2 2.1 6.4-0.2 1.7-5.8-3.8-5.8-3.8 0 0-4.9-6.5-0.7-8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m494.9 369q-0.3 0-0.4-0.3c-2.1-2.6-0.7-5.6 0.6-7-0.3-0.7-1-2.2-1.1-3 0-0.3 0.2-0.6 0.5-0.6 0.3-0.1 0.6 0.1 0.7 0.5 0.1 0.6 0.8 2.4 1.1 3 0.1 0.2 0 0.5-0.1 0.6-0.1 0.2-3 3.1-0.8 5.8 0.2 0.3 0.1 0.6-0.1 0.8q-0.2 0.2-0.4 0.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m490.7 365c-1.7 0-4-1.6-4.2-1.7-0.3-0.2-0.3-0.6-0.2-0.9 0.2-0.2 0.6-0.3 0.8-0.1 0.7 0.5 2.7 1.7 3.8 1.5q0.3 0 0.5-0.3c0.1-0.1 0.1-0.2 0.1-0.4-0.3-1.3-3-3.5-4.7-4.6-0.3-0.2-0.4-0.6-0.2-0.8 0.2-0.3 0.5-0.4 0.8-0.2 0.5 0.3 4.8 3.2 5.2 5.4q0.2 0.7-0.2 1.3-0.5 0.6-1.3 0.7-0.2 0.1-0.4 0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m488.5 368.5c-1.8 0-3.9-1.2-4.3-1.4-0.2-0.2-0.3-0.5-0.2-0.8 0.2-0.3 0.6-0.4 0.8-0.2 1.2 0.7 3.9 1.9 4.6 1 0-0.1 0.1-0.2 0.1-0.4-0.3-1.3-3.1-3.8-4.9-5-0.3-0.1-0.3-0.5-0.2-0.8 0.2-0.2 0.6-0.3 0.8-0.1 0.5 0.3 5 3.4 5.4 5.7q0.1 0.7-0.3 1.3c-0.4 0.5-1.1 0.7-1.8 0.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m487.7 372.3c-1.6 0-3.6-1.4-4.1-1.7-0.3-0.2-0.4-0.6-0.2-0.8 0.2-0.3 0.6-0.4 0.8-0.2 1.5 1.1 3.5 1.9 3.9 1.4q0.1-0.2 0.1-0.3c-0.2-1.1-3-3-4.9-4-0.3-0.1-0.4-0.5-0.3-0.7 0.2-0.3 0.5-0.4 0.8-0.3 0.9 0.4 5.1 2.8 5.5 4.7q0.1 0.8-0.3 1.3c-0.4 0.4-0.8 0.6-1.3 0.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m611.7 328.8c-36.3-3.1-69.8 57.6-69.8 57.6l-39-20.9-12.3 13.2c0 0 26.6 42.1 63.1 35 14.6-2.8 31.1-28.9 31.1-28.9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m571.5 415q-0.1 0-0.2 0c-0.3-0.1-0.5-0.4-0.4-0.7 3.1-13.5 8.2-39.8 8.2-40.1 0.1-0.3 0.4-0.5 0.7-0.5 0.3 0.1 0.5 0.4 0.5 0.7-0.1 0.3-5.2 26.6-8.3 40.2 0 0.2-0.3 0.4-0.5 0.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    clipPath: "url(#cp2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m187.9 266.9c0 0 10.6 42 7.9 67.6-2.5 24.2-17.9 39.8-39.5 39.8l-2.1 16.7c0 0-28.8 7.7-56.8-0.5l-0.4-38.4 0.2-81.2 10.4-16 72.2-10.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m124.8 366.9c2.9 2.9 29 18 30.1 18.5 0 0 1.6-13.4 1.5-11.7-0.1 0.6-5.8 1-12.8-1.1-6.4-1.8-12.9-4.8-17-6.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m153.7 375.7c-10.8 0-20.7-3.9-28.4-8.2-0.7-0.4-1-1.3-0.6-2 0.4-0.7 1.3-1 2.1-0.6 12.6 7.1 31.6 13 50.3 0.6 0.6-0.5 1.6-0.3 2 0.4 0.5 0.7 0.3 1.6-0.4 2-8.5 5.7-17 7.8-25 7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m104.3 311.5c-7.2-2.7-20.7-7.4-27.1-2-5.3 4.6-5.2 13.1-0.1 18.3 8.4 8.5 24 11.6 28.6 12.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m82.1 318.9c-0.5 0-1.1-0.3-1.3-0.9-0.3-0.7 0-1.6 0.7-2 6.2-2.7 10.8-0.7 11-0.6 0.8 0.4 1.1 1.3 0.7 2-0.3 0.7-1.2 1.1-1.9 0.7-0.2 0-3.7-1.5-8.5 0.7q-0.3 0.1-0.7 0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m89.3 325.5c-0.4 0-0.9-0.2-1.2-0.6 0-0.1-1.8-2.3-3.6-6.8-0.3-0.7 0-1.6 0.8-1.9 0.7-0.3 1.6 0 1.9 0.8 1.7 4 3.3 6.1 3.3 6.1 0.5 0.7 0.4 1.6-0.3 2.1q-0.4 0.3-0.9 0.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m144.4 226.2c-5.4 0.2-38.7 1.6-51.8 5.7-6.9 2.2-13.8 5.6-18.1 11.5-3.2 4.4-4.7 9.7-5.5 15.1-2.1 14.2 5.2 53.2 5.2 53.2 0 0 5.4-4.2 14.7-3.8 2.5 0.2 7.2 1.1 9.4 1.7 1 0.2 1.2 20.1 2.1 20l11.9-1.4c0.8 0-0.7-52-0.2-52.7 2.3-3 11.4-11.4 25.8-9.8 17.6 1.9 39.2 8.7 53.7-0.5 9.3-5.9 13.8-19 10.5-30.8-0.3-0.9-6.1-15.1-23.8-14.6-8.1 0.2-21.2 6.2-33.9 6.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m134.6 306.3c0.8 3.2 4.1 5.2 7.3 4.4 3.3-0.7 5.3-4 4.5-7.3-0.8-3.2-4.1-5.2-7.3-4.4-3.3 0.7-5.3 4-4.5 7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m177.4 299.7c-1.1-3.1-4.6-4.8-7.8-3.6-3.1 1.2-4.7 4.6-3.6 7.8 1.2 3.1 4.7 4.7 7.8 3.6 3.2-1.2 4.8-4.7 3.6-7.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m143.6 287.4c-1.7-1.4-4.8-1-7-0.5-2.1 0.4-5.9 1-7.4 2.6-0.7 0.9-0.9 2.1-0.4 3 0.6 1.2 2.2 1.8 3.7 1.9 1.4 0.1 2.8-0.2 4.2-0.4 1.8-0.3 3.6-0.7 5.5-1 0.4-0.1 0.9-0.3 1.3-0.5 1-0.6 1.2-2.7 1-3.5q-0.2-1.1-0.9-1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m165.2 285.3c1.3-1.8 4.4-2.1 6.6-2.2 2.2-0.2 6-0.6 7.8 0.6 1 0.6 1.5 1.8 1.2 2.7-0.3 1.4-1.6 2.4-3.1 2.9-1.3 0.4-2.7 0.5-4.1 0.6-1.8 0.2-3.7 0.4-5.6 0.5-0.4 0-0.9 0-1.4-0.1-1.1-0.4-1.8-2.3-1.9-3.2q0-1.1 0.5-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m158.5 319.6c-0.6 0-1.1-0.4-1.2-1-0.1-0.4-0.1-1.1-0.2-1.9-0.2-1.2-0.4-2.7-0.5-3.6-0.1-0.6 0.3-1.2 0.9-1.3 0.7-0.1 1.3 0.3 1.4 0.9 0.2 0.9 0.3 2.4 0.5 3.8 0.1 0.7 0.2 1.4 0.2 1.8 0.1 0.6-0.3 1.2-1 1.3q-0.1 0-0.1 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m158.8 325.2q-0.5 0-0.9-0.1c-0.7 0-1.1-0.6-1.1-1.3 0.1-0.6 0.7-1.1 1.3-1 0.7 0.1 2 0.1 2.9-0.6 0.6-0.5 0.9-1.4 0.6-2-0.2-0.2-0.5-0.5-0.8-0.6-0.7-0.4-1.6-0.4-2.3-0.1-0.6 0.2-1.3-0.1-1.5-0.7-0.2-0.6 0.1-1.3 0.7-1.5 1.3-0.5 2.7-0.4 4 0.1 0.9 0.4 1.5 1 1.9 1.7 0.9 1.5 0.4 3.7-1.2 4.9-1.1 0.9-2.5 1.2-3.6 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m156.7 340.9c-3.4 0-6.7-1.1-9.4-3.3-0.5-0.4-0.5-1.1-0.1-1.6 0.4-0.5 1.1-0.6 1.6-0.2 3.8 3.1 9.4 3.7 13.7 1.3 0.5-0.3 1.3-0.1 1.6 0.5 0.3 0.6 0.1 1.3-0.5 1.6-2.1 1.1-4.5 1.7-6.9 1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m111.6 312c0 14-11.4 25.4-25.4 25.4-14 0-25.4-11.4-25.4-25.4 0-14 11.4-25.4 25.4-25.4 14 0 25.4 11.4 25.4 25.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m98.3 312c0 6.7-5.4 12.1-12.1 12.1-6.7 0-12.1-5.4-12.1-12.1 0-6.7 5.4-12.1 12.1-12.1 6.7 0 12.1 5.4 12.1 12.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s1",
    d: "m86.2 330.1c-10 0-18.1-8.1-18.1-18.1 0-10 8.1-18.1 18.1-18.1 10 0 18.1 8.1 18.1 18.1 0 10-8.1 18.1-18.1 18.1zm0-33.8c-8.6 0-15.7 7.1-15.7 15.7 0 8.6 7.1 15.7 15.7 15.7 8.6 0 15.7-7.1 15.7-15.7 0-8.6-7.1-15.7-15.7-15.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m75.5 291.4c0 0-1.7-20.8 12-41.3 10.1-15.2 35.8-28.3 57.4-23.6 0 0-27.7 5.7-43.5 25.6-13.6 17.2-11.5 38.3-11.5 38.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m31.3 494.4c0 0 5.3 62.1 7.1 68.7 1.8 6.6 4.8 24.4 24.1 28 26.1 5.1 128.6 1.5 128.6 1.5l-11.7-28-97.3-19.1-4.5-48.4z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m349.6 565.1l5.1 23.5c0 0-69.8 2.8-115-1.9-14.2-1.5-58-68.9-58-68.9l43.5-31.9 25 52.6z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m208.3 403.6c-25.8-17-53.6-16.9-53.6-16.9 0 0-14 8.5-28.5 7.2-14.5-1.2-27.4-5.7-28.4-9.6 0 0-40.9 4.3-59.6 28.7-15.3 19.9-12.6 95-12.6 95l53-1.6-21.3 81.1h141.4l-1.5-65.2 46.7-28.1c0 0-22.1-81.7-35.6-90.6z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m197.9 538.1c-0.7 0-1.2-0.5-1.2-1.1v-35.6c0-0.6 0.5-1.1 1.2-1.1 0.6 0 1.1 0.5 1.1 1.1v35.6c0 0.6-0.5 1.1-1.1 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m124.6 477l-14.6 115.9 93.2 11.7c3.7 0.5 7.1-2 7.5-5.6l13-103c0.4-3.6-2.2-6.8-5.9-7.3z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m125 473.6l-15 118.9 88 11.1c3.7 0.5 7-2.1 7.5-5.8l13.3-105.6c0.5-3.7-2.2-7.1-5.9-7.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m198 603.6l-88-11.1 6.2-49c0 0 20.2 25.5 42.5 40.3 22.4 14.8 39.3 19.8 39.3 19.8z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m186.6 511q-0.1 0-0.2 0l-34.4-4.4c-0.8-0.1-1.3-0.8-1.2-1.6 0.1-0.8 0.8-1.3 1.5-1.2l34.5 4.4c0.8 0.1 1.3 0.8 1.2 1.5-0.1 0.8-0.7 1.3-1.4 1.3z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m186 519.4q-0.1 0-0.2-0.1l-34.4-4.4c-0.8-0.1-1.3-0.8-1.3-1.5 0.1-0.8 0.8-1.4 1.6-1.3l34.5 4.4c0.8 0.1 1.3 0.8 1.2 1.6-0.1 0.7-0.7 1.3-1.4 1.3z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m115.5 588.4q-0.1 0-0.2 0c-0.7-0.1-1.3-0.8-1.2-1.6l13.7-107.9c0.1-0.8 0.8-1.3 1.6-1.2 0.8 0.1 1.3 0.8 1.2 1.6l-13.7 107.9c-0.1 0.7-0.7 1.2-1.4 1.2z"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m35.8 542.7c1 10 2 18.2 2.6 20.4 1.8 6.6 4.8 24.4 24.1 28 26.1 5.1 128.6 1.5 128.6 1.5l-11.7-28-97.3-19.1-3.5-39z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m174.5 564c0 0 4.2-1.2 11.4-1 9.7 0.2 21.4-3.4 29.6-4 4.1-0.2 5.7 1.2 6.1 2.6 0.9 3.5-2.5 5.6-2.5 5.6 3.3 0.8 5.5 0.7 5.9 4.3 0.4 4-5.7 4.9-5.7 4.9 0 0 4.1 0 4.5 4.3 0.4 4.5-6.3 5-8 5.7 0 0 2 1.2 2.3 2.8 0.3 1.4-0.9 3.3-2.7 3.9-1 0.4-10.9 1.8-21.4 0.8-9.4-0.9-21.9-1.5-21.9-1.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m200.8 595c-4 0-8.1-0.1-11.4-0.5-0.7-0.1-1.2-0.7-1.1-1.3 0.1-0.6 0.7-1.1 1.3-1 9.6 1 24.3 0.1 25.5-0.2 1.2-0.4 2-1.8 1.9-2.5-0.2-1-1.5-1.9-1.8-2.1-0.4-0.2-0.6-0.6-0.6-1.1 0.1-0.4 0.4-0.8 0.8-1 0.4-0.2 1-0.3 1.7-0.5 3-0.7 5.7-1.6 5.5-4-0.2-3-2.7-3.2-3.2-3.2q0 0 0 0 0 0 0 0c-0.7 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.1 1.1-1.1q0.1 0 0.1 0c1.8 0 5.2 1.1 5.6 5.3 0.3 4.3-4 5.7-6.8 6.4 0.5 0.5 0.9 1.2 1.1 2 0.4 2-1.2 4.4-3.4 5.2-0.9 0.3-7.8 0.8-15.1 0.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m202 552.7c-2.6-3.7-7.7-0.5-13.5 3.8-2.8 2.1-8.6 5.3-9.7 7.4-1.6 3.2 12.8 1.3 12.8 1.3 0 0 15.6-5.2 10.4-12.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m219.3 577.6c-0.5 0-1-0.4-1.1-1-0.1-0.6 0.3-1.2 1-1.3 0 0 4.9-0.9 4.6-3.7-0.2-2.2-1.1-2.4-3.6-3q-0.7-0.1-1.4-0.3c-0.4-0.1-0.8-0.5-0.8-0.9-0.1-0.5 0.1-1 0.5-1.2 0.1-0.1 2.6-1.7 1.9-4.3-0.3-1.2-2.1-1.9-4.8-1.7-3.3 0.2-7.3 1-11.4 1.7q-2.7 0.5-5.4 1c-0.5 0.1-1-0.2-1.3-0.7-0.2-0.5 0-1.1 0.5-1.4 2.2-1.5 3.6-3.1 3.8-4.6q0.3-1.4-0.8-2.9c-0.4-0.6-0.9-0.9-1.6-1-2.3-0.4-6.3 2.3-10.2 5.2-0.9 0.6-2 1.3-3.1 2.1-2.3 1.4-4.8 3.1-5.9 4.4-0.2 0.2-0.4 0.3-0.7 0.4-3.3 0.3-10.2-0.6-10.5-0.7-0.6-0.1-1.1-0.7-1-1.3 0.1-0.6 0.7-1.1 1.3-1 0.1 0 6.3 0.8 9.5 0.7 1.4-1.5 3.7-3 6-4.5 1.1-0.7 2.2-1.4 3-2 5.1-3.8 9-6.1 12-5.6q1.9 0.3 3.2 2 1.6 2.3 1.1 4.6-0.3 1.7-1.5 3.3 0.5-0.2 1.1-0.3c4.3-0.8 8.3-1.5 11.7-1.7 5.7-0.4 7 2.3 7.3 3.4 0.6 2.1-0.2 4-1.2 5.2 2.3 0.6 4.3 1.4 4.7 4.9 0.4 4-4 5.8-6.7 6.2q-0.1 0-0.2 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m214.2 587.5c-2.8 0-5.5-0.1-7.7-0.3-0.7-0.1-1.2-0.6-1.1-1.3 0-0.6 0.6-1.1 1.2-1 2.8 0.2 6.5 0.4 10.2 0.2 0.7 0.1 1.2 0.5 1.3 1.2 0 0.6-0.5 1.1-1.2 1.2q-1.3 0-2.7 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m206.9 578.3c-0.6 0-1.2-0.5-1.2-1.2 0-0.6 0.6-1.1 1.2-1.2 3.6 0 6.8-0.2 10.4-0.4q1.8-0.2 3.9-0.3c0.7 0 1.2 0.4 1.3 1.1 0 0.6-0.5 1.2-1.1 1.2q-2.1 0.2-4 0.3c-3.6 0.3-6.8 0.5-10.5 0.5q0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m206.9 569c-0.6 0-1.1-0.5-1.1-1.2-0.1-0.6 0.5-1.1 1.1-1.1 5.4-0.1 8-0.3 13.3-1.1 0.6-0.1 1.2 0.4 1.3 1 0.1 0.6-0.4 1.2-1 1.3-5.4 0.8-8 1-13.6 1.1q0 0 0 0z"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m31.3 508.5c-0.6 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.2 1.2-1.2l54.2-1.6-0.7-22c-0.1-0.7 0.4-1.2 1.1-1.3 0.6 0 1.2 0.5 1.2 1.2l0.8 23.2c0 0.3-0.1 0.6-0.3 0.9-0.2 0.2-0.5 0.3-0.8 0.3l-55.5 1.7q0 0 0 0z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m126 396c-20.5 0-29-10-29.3-10.4-0.5-0.5-0.4-1.3 0.1-1.7 0.5-0.4 1.2-0.3 1.7 0.2 0 0.1 8.4 9.8 28.1 9.5 20.7-0.2 27.7-7.8 27.8-7.9 0.4-0.5 1.2-0.5 1.7-0.1 0.5 0.4 0.5 1.1 0.1 1.6-0.3 0.4-7.7 8.6-29.6 8.8q-0.3 0-0.6 0z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m379.2 564.1c-6.1-1.5-23.7 0.1-29.7 1.6-5.1 1.4-7.9 6.7-7.9 6.7l3.8 15.2c0 0 7.9 2.2 14.9 1 4.6-0.8 24.7-4.5 26.8-3.1 2.8 1.9 5.6-0.5 5.5-1.5 0-0.3-0.2-1.2-0.7-2.2q0.3 0 0.6 0c3.6-0.4 1.6-4.3 1.6-4.3q-0.3-0.2-0.6-0.4c1.7 0.3 1.2-0.6 1.5-1.5 2-4.7-9.7-10-15.8-11.5z"
  }))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m624.7 443.7h-185.3c-8.6 0-15.5 5.9-15.5 13.2l-43 116.7-91.6 15.9c-2.6 0 49 0.7 85.3 1.1l-0.2 0.4h216.3l49.5-134.1c0-7.3-7-13.2-15.5-13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m624.7 443.7h-185.3c-8.6 0-15.5 5.9-15.5 13.2l-43 116.7-91.6 15.9c-2.6 0 49 0.7 85.3 1.1l-0.2 0.4h216.3l49.5-134.1c0-7.3-7-13.2-15.5-13.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m538.7 513.9c0 12.6-10.3 22.9-22.9 22.9-12.7 0-22.9-10.3-22.9-22.9 0-12.7 10.2-23 22.9-23 12.6 0 22.9 10.3 22.9 23z"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m670.1 606.3h-647.7c-4.2 0-7.6-3.4-7.6-7.6v-3.4c0-4.2 3.4-7.6 7.6-7.6h647.7c4.2 0 7.6 3.4 7.6 7.6v3.4c0 4.2-3.4 7.6-7.6 7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m647.3 549.3c0 0-14.3-21.9-10.1-39.3 2.2-9.2 9.6-15.5 16.1-21.6 8.3-7.8 10.7-12.2 11.2-23.8 0.2-5 0.6-10.1 3.1-14.5 2.4-4.3 7.4-7.6 12.2-6.5 4.4 0.9 7.5 5.2 8.3 9.6 0.9 4.5-0.2 9-1.6 13.3-3 9.2-7.6 18-14.1 25.2-5.9 6.5-15.8 11.1-19.9 18.9-9.4 18-5.2 38.7-5.2 38.7z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m619.8 541.8l5.4 47.3c0 0 32.5 2.4 39.7-0.8l6.9-46.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s5",
    d: "m618.3 573.8q-0.1 0-0.2 0c-3.2 0-6.2-1.3-8.4-3.6-2.2-2.3-3.4-5.3-3.3-8.5 0.1-6.5 5.4-11.7 11.9-11.7q0.1 0 0.2 0c3.1 0 6.1 1.3 8.3 3.6 2.2 2.3 3.4 5.3 3.4 8.5-0.1 3.2-1.3 6.1-3.6 8.3-2.3 2.2-5.2 3.4-8.3 3.4zm0-18.7c-3.7 0-6.8 3-6.8 6.7-0.1 1.8 0.6 3.5 1.9 4.8 1.3 1.3 3 2.1 4.8 2.1 1.8 0 3.5-0.7 4.8-1.9 1.3-1.3 2.1-3 2.1-4.8 0-1.8-0.7-3.5-1.9-4.8-1.3-1.3-3-2.1-4.8-2.1q-0.1 0-0.1 0z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>",
    style: {
      opacity: 0.1
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m673.8 507.9c-3.6-1.5-8 0.8-11.1 3.2-3.1 2.4-4.4 7.5-1.6 10.2 2.1 2.1 5.7 1.9 8.4 0.7 3.2-1.3 5.9-4 6.5-7.4 0.6-3.4-0.6-6.1-2.2-6.7z"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m671 548.1h-50.2c-0.6 0-1.1-0.5-1.1-1.1 0-0.7 0.5-1.2 1.1-1.2h50.2c0.7 0 1.2 0.5 1.2 1.2 0 0.6-0.5 1.1-1.2 1.1z"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m665.3 585.4h-40.8c-0.6 0-1.1-0.5-1.1-1.1 0-0.7 0.5-1.2 1.1-1.2h40.8c0.7 0 1.2 0.5 1.2 1.2 0 0.6-0.5 1.1-1.2 1.1z"
  }))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m787.6 351.5h-80.1c-5.1 0-9.2-4.1-9.2-9.2v-25.3c0-5 4.1-9.1 9.2-9.1h80.1c5 0 9.1 4.1 9.1 9.1v25.3c0 5.1-4.1 9.2-9.1 9.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m742.2 325.3h-27.8c-1.2 0-2.3-1-2.3-2.3 0-1.3 1.1-2.3 2.3-2.3h27.8c1.3 0 2.4 1 2.4 2.3 0 1.3-1.1 2.3-2.4 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m770.1 337.9h-55.7c-1.2 0-2.3-1-2.3-2.3 0-1.3 1.1-2.3 2.3-2.3h55.7c1.3 0 2.3 1 2.3 2.3 0 1.3-1 2.3-2.3 2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m780.4 294.2h-74.8c-4 0-7.3-3.3-7.3-7.3v-35.9c0-4 3.3-7.3 7.3-7.3h74.8c4 0 7.2 3.3 7.2 7.3v35.9c0 4-3.2 7.3-7.2 7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m744.2 259.4h-33c-1.1 0-1.9-0.8-1.9-1.9 0-1 0.8-1.8 1.9-1.8h33c1.1 0 1.9 0.8 1.9 1.8 0 1.1-0.8 1.9-1.9 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m766.4 269.4h-55.2c-1.1 0-1.9-0.8-1.9-1.8 0-1.1 0.8-1.9 1.9-1.9h55.2c1.1 0 1.9 0.8 1.9 1.9 0 1-0.8 1.8-1.9 1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m766.4 280h-55.2c-1.1 0-1.9-0.8-1.9-1.8 0-1.1 0.8-1.9 1.9-1.9h55.2c1.1 0 1.9 0.8 1.9 1.9 0 1-0.8 1.8-1.9 1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m368.7 162.3h-85.3c-5 0-9.1-4-9.1-9.1v-25.3c0-5 4.1-9.1 9.1-9.1h85.3c5.1 0 9.2 4.1 9.2 9.1v25.3c0 5.1-4.1 9.1-9.2 9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m323.4 136.2h-33c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.3 2.3-2.3h33c1.3 0 2.4 1 2.4 2.3 0 1.3-1.1 2.3-2.4 2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m351.3 148.8h-60.9c-1.3 0-2.3-1-2.3-2.3 0-1.3 1-2.4 2.3-2.4h60.9c1.3 0 2.3 1.1 2.3 2.4 0 1.3-1 2.3-2.3 2.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m251.8 194.7h-70.2c-4 0-7.3-3.3-7.3-7.3v-35.9c0-4 3.3-7.3 7.3-7.3h70.2c4 0 7.3 3.3 7.3 7.3v35.9c0 4-3.3 7.3-7.3 7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m215.7 159.9h-28.5c-1.1 0-1.9-0.9-1.9-1.9 0-1 0.8-1.9 1.9-1.9h28.5c1 0 1.9 0.9 1.9 1.9 0 1-0.9 1.9-1.9 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m237.9 169.9h-50.7c-1.1 0-1.9-0.9-1.9-1.9 0-1 0.8-1.8 1.9-1.8h50.7c1 0 1.9 0.8 1.9 1.8 0 1-0.9 1.9-1.9 1.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m237.9 180.5h-50.7c-1.1 0-1.9-0.9-1.9-1.9 0-1 0.8-1.8 1.9-1.8h50.7c1 0 1.9 0.8 1.9 1.8 0 1-0.9 1.9-1.9 1.9z"
  })))))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m508.6 670.9l-18.1-7-15.2 12.2 3.1 19.2 18.1 7 15.1-12.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m513.4 104.4l-17.4 8.5-1.4 19.4 16.1 10.9 17.5-8.6 1.4-19.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m687.7 18.9l-16.2 36.1 38.8-7.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m201.4 650.3l-39.1-5.7 17.8 35.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m382.8 29c0 7.2-5.8 13.1-13 13.1-7.2 0-13-5.9-13-13.1 0-7.2 5.8-13 13-13 7.2 0 13 5.8 13 13z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m539.5 40.6c-0.7 0-1.2-0.5-1.2-1.1v-13.5c0-0.7 0.5-1.2 1.2-1.2 0.6 0 1.1 0.5 1.1 1.2v13.5c0 0.6-0.5 1.1-1.1 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m546.2 33.9h-13.5c-0.6 0-1.1-0.5-1.1-1.2 0-0.6 0.5-1.1 1.1-1.1h13.5c0.7 0 1.2 0.5 1.2 1.1 0 0.7-0.5 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m13.9 355.7c-0.6 0-1.2-0.5-1.2-1.2v-13.5c0-0.7 0.6-1.2 1.2-1.2 0.7 0 1.2 0.5 1.2 1.2v13.5c0 0.7-0.5 1.2-1.2 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m20.7 348.9h-13.6c-0.6 0-1.1-0.5-1.1-1.1 0-0.7 0.5-1.2 1.1-1.2h13.6c0.6 0 1.1 0.5 1.1 1.2 0 0.6-0.5 1.1-1.1 1.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m344.1 711.1c-0.7 0-1.2-0.5-1.2-1.1v-13.5c0-0.7 0.5-1.2 1.2-1.2 0.6 0 1.2 0.5 1.2 1.2v13.5c0 0.6-0.6 1.1-1.2 1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m350.8 704.4h-13.5c-0.6 0-1.1-0.5-1.1-1.2 0-0.6 0.5-1.2 1.1-1.2h13.5c0.7 0 1.2 0.6 1.2 1.2 0 0.7-0.5 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m734.9 566.3c-0.6 0-1.1-0.6-1.1-1.2v-13.5c0-0.7 0.5-1.2 1.1-1.2 0.7 0 1.2 0.5 1.2 1.2v13.5c0 0.6-0.5 1.2-1.2 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m741.7 559.5h-13.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.1 1.2-1.1h13.5c0.6 0 1.2 0.5 1.2 1.1 0 0.7-0.6 1.2-1.2 1.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m783.8 170.4c-0.7 0-1.2-0.6-1.2-1.2v-13.5c0-0.7 0.5-1.2 1.2-1.2 0.6 0 1.1 0.5 1.1 1.2v13.5c0 0.6-0.5 1.2-1.1 1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m790.5 163.6h-13.5c-0.7 0-1.2-0.5-1.2-1.2 0-0.6 0.5-1.1 1.2-1.1h13.5c0.7 0 1.2 0.5 1.2 1.1 0 0.7-0.5 1.2-1.2 1.2z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5245473PersonAi);
export default __webpack_public_path__ + "static/media/5245473-person-ai.4bed53de7465c555f40f0e0036e61d76.svg";
export { ForwardRef as ReactComponent };